module.exports = __webpack_public_path__ + "static/media/prysmatic-bg.7bab1421.png";